module.exports = __webpack_public_path__ + "img/RA.6d015fe9.png";